import { render } from "./VTreatmentTime.vue?vue&type=template&id=07c89e41"
import script from "./VTreatmentTime.vue?vue&type=script&lang=js"
export * from "./VTreatmentTime.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/bookdialysis/bookdialysis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__